import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-editar-issue',
  templateUrl: './editar-issue.component.html',
  styleUrls: ['./editar-issue.component.scss'],
})
export class EditarIssueComponent implements OnInit {

  @Input() isModal;
  supplierComment = '';

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {}

  enviar() {
    this.modalCtrl.dismiss({supplierComment: this.supplierComment});
  }

}
